import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { Icon, InfiniteTable, DLMenu } from 'appSrc/components/UI';
import TextTruncate from 'react-text-truncate';
import EditBrandModal from '../../Modals/Brand/EditBrandModal';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';
import { convertImage } from 'appSrc/utils';

class AllBrandsTable extends PureComponent {
    
    constructor( props ) {
        super( props );
        this.state = {
            brandInEdit: null,
            brandInEditIndex: -1,
        };
    }

    updateBrand = ( index, id, data ) => {
        this.props.updateBrand( id, data )
        .then( ( brand ) => {
            return this.props.onBrandUpdated && this.props.onBrandUpdated( index, brand );
        } );
    }

    openEditModal = ( index, brand ) => {
        this.setState( { brandInEdit: brand, brandInEditIndex: index } );
    }
    
    onEditSubmit = ( brand ) => {
        var index = this.state.brandInEditIndex;
        this.props.onBrandUpdated( index, brand );
        this.setState( { brandInEdit: null, brandInEditIndex: -1 } );
    }

    onEditClose = () => {
        this.setState( { brandInEdit: null, brandInEditIndex: -1 } );
    }

    render() {
        const { brands } = this.props;

        return (
            <div>
                <InfiniteTable
                loadMore={ this.props.loadMore }
                elementHeight={ 70 }>
                    { this.arrayTableRows( brands ) }
                </InfiniteTable>
                { this.state.brandInEdit &&
                    <EditBrandModal closeModal={ this.onEditClose }
                    onSubmit={ this.onEditSubmit }
                    brand={ this.state.brandInEdit } />
                }
            </div>
        );
    }

    arrayTableRows = ( brands ) => {
        var rows = brands.map( ( brand, index ) => {
            var individualSlug = `/admin/brands/${ brand.id }`;
            return (
                <InfiniteTable.Row key={ brand.id } className='dl-table-body'>
                    <InfiniteTable.Cell className={ style.coverImage }>
                        <Link to={ individualSlug }></Link>
                        <img src={ convertImage( brand.logo, '/100x100' ) } />
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        <Link to={ individualSlug }></Link>
                        <TextTruncate text={ brand.name }
                        line={ 2 } />
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        <Link to={ individualSlug }></Link>
                        { brand.embed ? ( <Icon source='fontAwesome' icon='fas/faCheck' style={ { color: 'inheirit' } } /> ) : null }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        <Link to={ individualSlug }></Link>
                        { brand.published ? ( <Icon source='fontAwesome' icon='fas/faCheck' style={ { color: 'inheirit' } } /> ) : null }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        <DLMenu
                        icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                        direction='left' >
                            <DLMenu.Item text='Edit'
                            onClick={ () => {
                                this.openEditModal( index, brand );
                            } }/>
                            <DLMenu.Item text={ !brand.embed ? 'Enable Embeds' : 'Disable Embeds' }
                            onClick={ () => {
                                brand.embed = !brand.embed;
                                this.updateBrand( index, brand.id, brand );
                            } }/>
                            <DLMenu.Item text={ !brand.published ? 'Publish' : 'Unpublish' }
                            onClick={ () => {
                                brand.published = !brand.published;
                                this.updateBrand( index, brand.id, brand );
                            } }/>
                        </DLMenu>
                    </InfiniteTable.Cell>
                </InfiniteTable.Row>
            );
        } );

        const currentSort = this.props.currentSort;
        const sortIcon = ( value ) => {
            if( currentSort == value ) {
                return (
                    <Icon source='fontAwesome'
                    icon='fas/faSortUp'
                    style={ { cursor: 'pointer' } }
                    onClick={ () => { this.props.onColumnSort( value ); } } />
                );
            }
            if( currentSort == `-${ value }` ) {
                return (
                    <Icon source='fontAwesome'
                    icon='fas/faSortDown'
                    style={ { cursor: 'pointer' } }
                    onClick={ () => { this.props.onColumnSort( value ); } } />
                );
            }
            return (
                <Icon source='fontAwesome'
                icon='fas/faSort'
                style={ { cursor: 'pointer' } }
                onClick={ () => { this.props.onColumnSort( value ); } } />
            );
        };

        rows.unshift( (
            <InfiniteTable.Row key='-1' className='dl-table-head'>
                <InfiniteTable.Cell></InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    BRAND NAME { sortIcon( 'name,id' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    EMBED { sortIcon( 'embed,name,id' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    PUBLISHED { sortIcon( 'published,name,id' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>ACTIONS</InfiniteTable.Cell>
            </InfiniteTable.Row>
        ) );

        return rows;
    }
}
AllBrandsTable.defaultProps = {
    onBrandUpdated: ()=>{},
};

const mapDispatchToProps = () => {
    return {
        updateBrand: ( id, data ) => {
            return dAPI.patch( `/admin/brands/${ id }`, data );
        },
    };
};

export default connect( null, mapDispatchToProps )( AllBrandsTable );
